<header class="lv-offcanvas-pane-header">
    <h1 class="flex-grow-1">
        @if(titleIconClass()){
        <i class="fa-light fa-xs me-2" [class]="titleIconClass()"></i>
        }
        <span [innerHtml]="title()"></span>
    </h1>
</header>
<section class="lv-offcanvas-pane-body">
    <ng-content select="[body]"></ng-content>
</section>
<footer class="lv-offcanvas-pane-footer">
    <ng-content select="[footer]"></ng-content>
</footer>
